import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { getLeadersAndUsersByPermission } from "api/User";


export const useLeadersAndUsersByPermission = (permissions: any) => {

    const { data, isLoading } = useQuery<Array<any>>(
        ['leaders-users-by-permission'],
        () => {
            return getLeadersAndUsersByPermission(permissions);
        }, {
        onError() {
            toast.error(`Something went wrong. Please try again later.`);
        },
    }
    );

    return {
        data,
        isLoading,
    };
};
